import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';

@Injectable()
export class CustomPageTitleStrategy extends TitleStrategy {
	constructor(
		private translateService: TranslocoService,
		private readonly title: Title,
	) {
		super();
	}

	override updateTitle(snapshot: RouterStateSnapshot): void {
		const title = this.buildTitle(snapshot);
		if (title) {
			this.translateService.selectTranslate(title).subscribe((translatedTitle) => {
				this.title.setTitle(translatedTitle);
			});
		} else {
			this.title.setTitle('MyZEISS Store');
		}
	}
}
